import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { AuthProvider, BrandProvider } from '@aralere/shared-ui';
import { App } from './App';
import './styles/global.css';

const root = document.getElementById('root');
if (!root) throw new Error('No #root');

createRoot(root).render(
  <StrictMode>
    <BrowserRouter>
      <BrandProvider>
        <AuthProvider>
          <App />
        </AuthProvider>
      </BrandProvider>
    </BrowserRouter>
  </StrictMode>
);
